import { toast } from "react-toastify";
import API from "./../../helpers/api/api_interceptor";
import { ADD_AUCTION_TAGS, DELETE_AUCTION_TAGS, EDIT_AUCTION_TAGS, SET_AUCTION_TAGS_LIST } from "./actionType";

export const getAuctionTags = (params) => async (dispatch) => {
  try {
    return API.get(`/auctions/tags`, {
      params: {
        page_number: params.page,
        page_size: params.limit,
        search: params.search,
        filter: params.filter,
        sort: params.sort,
      },
    }).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: SET_AUCTION_TAGS_LIST,
          payload: {
            data: res?.data?.data?.results,
            total: res?.data?.data?.count,
          },
        });
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const addAuctionTags = (payload) => async (dispatch) => {
  try {
    return API.post(`/auctions/tags`, payload).then((res) => {
      if (res && res.status && res.status === 201) {
        dispatch({
          type: ADD_AUCTION_TAGS,
          payload: {
            data: res?.data?.data,
          },
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};

export const editAuctionTags =
  ({ id, values }) =>
  async (dispatch) => {
    try {
      return API.put(`/auctions/tags/${id}`, values).then((res) => {
        if (res && res.status && res.status === 200) {
          dispatch({
            type: EDIT_AUCTION_TAGS,
            payload: {
              data: res?.data?.data,
            },
          });
          toast.success(res?.data?.detail);
          return true;
        } else {
          return false;
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

export const deleteAuctionTags = (id) => async (dispatch) => {
  try {
    return API.delete(`/auctions/tags/${id}`).then((res) => {
      if (res && res.status && res.status === 200) {
        dispatch({
          type: DELETE_AUCTION_TAGS,
          payload: {
            deletedId: id,
          },
        });
        toast.success(res?.data?.detail);
        return true;
      } else {
        return false;
      }
    });
  } catch (error) {
    console.log(error);
  }
};
